/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TicketingIndexRouteImport } from './routes/ticketing/index'
import { Route as ProviderNetworkIndexRouteImport } from './routes/provider-network/index'
import { Route as CopyDevTokenIndexRouteImport } from './routes/copy-dev-token/index'
import { Route as ComponentCatalogIndexRouteImport } from './routes/component-catalog/index'
import { Route as ChangeToE2eIndexRouteImport } from './routes/change-to-e2e/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as ProviderNetworkProvidersIndexRouteImport } from './routes/provider-network/providers/index'
import { Route as ProviderNetworkGroupsIndexRouteImport } from './routes/provider-network/groups/index'
import { Route as ProviderNetworkClinicsIndexRouteImport } from './routes/provider-network/clinics/index'
import { Route as AuthCallbackIndexRouteImport } from './routes/auth/callback/index'
import { Route as AnalyticsReportReportIdRouteImport } from './routes/analytics/report/$reportId'
import { Route as ProviderNetworkProviderProviderIdIndexRouteImport } from './routes/provider-network/provider/$providerId/index'
import { Route as ProviderNetworkGroupGroupIdIndexRouteImport } from './routes/provider-network/group/$groupId/index'
import { Route as ProviderNetworkClinicClinicIdIndexRouteImport } from './routes/provider-network/clinic/$clinicId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketingIndexRoute = TicketingIndexRouteImport.update({
  id: '/ticketing/',
  path: '/ticketing/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderNetworkIndexRoute = ProviderNetworkIndexRouteImport.update({
  id: '/provider-network/',
  path: '/provider-network/',
  getParentRoute: () => rootRouteImport,
} as any)
const CopyDevTokenIndexRoute = CopyDevTokenIndexRouteImport.update({
  id: '/copy-dev-token/',
  path: '/copy-dev-token/',
  getParentRoute: () => rootRouteImport,
} as any)
const ComponentCatalogIndexRoute = ComponentCatalogIndexRouteImport.update({
  id: '/component-catalog/',
  path: '/component-catalog/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangeToE2eIndexRoute = ChangeToE2eIndexRouteImport.update({
  id: '/change-to-e2e/',
  path: '/change-to-e2e/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderNetworkProvidersIndexRoute =
  ProviderNetworkProvidersIndexRouteImport.update({
    id: '/provider-network/providers/',
    path: '/provider-network/providers/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProviderNetworkGroupsIndexRoute =
  ProviderNetworkGroupsIndexRouteImport.update({
    id: '/provider-network/groups/',
    path: '/provider-network/groups/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProviderNetworkClinicsIndexRoute =
  ProviderNetworkClinicsIndexRouteImport.update({
    id: '/provider-network/clinics/',
    path: '/provider-network/clinics/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthCallbackIndexRoute = AuthCallbackIndexRouteImport.update({
  id: '/auth/callback/',
  path: '/auth/callback/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsReportReportIdRoute = AnalyticsReportReportIdRouteImport.update({
  id: '/analytics/report/$reportId',
  path: '/analytics/report/$reportId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderNetworkProviderProviderIdIndexRoute =
  ProviderNetworkProviderProviderIdIndexRouteImport.update({
    id: '/provider-network/provider/$providerId/',
    path: '/provider-network/provider/$providerId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProviderNetworkGroupGroupIdIndexRoute =
  ProviderNetworkGroupGroupIdIndexRouteImport.update({
    id: '/provider-network/group/$groupId/',
    path: '/provider-network/group/$groupId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProviderNetworkClinicClinicIdIndexRoute =
  ProviderNetworkClinicClinicIdIndexRouteImport.update({
    id: '/provider-network/clinic/$clinicId/',
    path: '/provider-network/clinic/$clinicId/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/change-to-e2e/': typeof ChangeToE2eIndexRoute
  '/component-catalog/': typeof ComponentCatalogIndexRoute
  '/copy-dev-token/': typeof CopyDevTokenIndexRoute
  '/provider-network/': typeof ProviderNetworkIndexRoute
  '/ticketing/': typeof TicketingIndexRoute
  '/analytics/report/$reportId': typeof AnalyticsReportReportIdRoute
  '/auth/callback/': typeof AuthCallbackIndexRoute
  '/provider-network/clinics/': typeof ProviderNetworkClinicsIndexRoute
  '/provider-network/groups/': typeof ProviderNetworkGroupsIndexRoute
  '/provider-network/providers/': typeof ProviderNetworkProvidersIndexRoute
  '/provider-network/clinic/$clinicId/': typeof ProviderNetworkClinicClinicIdIndexRoute
  '/provider-network/group/$groupId/': typeof ProviderNetworkGroupGroupIdIndexRoute
  '/provider-network/provider/$providerId/': typeof ProviderNetworkProviderProviderIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/change-to-e2e': typeof ChangeToE2eIndexRoute
  '/component-catalog': typeof ComponentCatalogIndexRoute
  '/copy-dev-token': typeof CopyDevTokenIndexRoute
  '/provider-network': typeof ProviderNetworkIndexRoute
  '/ticketing': typeof TicketingIndexRoute
  '/analytics/report/$reportId': typeof AnalyticsReportReportIdRoute
  '/auth/callback': typeof AuthCallbackIndexRoute
  '/provider-network/clinics': typeof ProviderNetworkClinicsIndexRoute
  '/provider-network/groups': typeof ProviderNetworkGroupsIndexRoute
  '/provider-network/providers': typeof ProviderNetworkProvidersIndexRoute
  '/provider-network/clinic/$clinicId': typeof ProviderNetworkClinicClinicIdIndexRoute
  '/provider-network/group/$groupId': typeof ProviderNetworkGroupGroupIdIndexRoute
  '/provider-network/provider/$providerId': typeof ProviderNetworkProviderProviderIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/change-to-e2e/': typeof ChangeToE2eIndexRoute
  '/component-catalog/': typeof ComponentCatalogIndexRoute
  '/copy-dev-token/': typeof CopyDevTokenIndexRoute
  '/provider-network/': typeof ProviderNetworkIndexRoute
  '/ticketing/': typeof TicketingIndexRoute
  '/analytics/report/$reportId': typeof AnalyticsReportReportIdRoute
  '/auth/callback/': typeof AuthCallbackIndexRoute
  '/provider-network/clinics/': typeof ProviderNetworkClinicsIndexRoute
  '/provider-network/groups/': typeof ProviderNetworkGroupsIndexRoute
  '/provider-network/providers/': typeof ProviderNetworkProvidersIndexRoute
  '/provider-network/clinic/$clinicId/': typeof ProviderNetworkClinicClinicIdIndexRoute
  '/provider-network/group/$groupId/': typeof ProviderNetworkGroupGroupIdIndexRoute
  '/provider-network/provider/$providerId/': typeof ProviderNetworkProviderProviderIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics/'
    | '/change-to-e2e/'
    | '/component-catalog/'
    | '/copy-dev-token/'
    | '/provider-network/'
    | '/ticketing/'
    | '/analytics/report/$reportId'
    | '/auth/callback/'
    | '/provider-network/clinics/'
    | '/provider-network/groups/'
    | '/provider-network/providers/'
    | '/provider-network/clinic/$clinicId/'
    | '/provider-network/group/$groupId/'
    | '/provider-network/provider/$providerId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/change-to-e2e'
    | '/component-catalog'
    | '/copy-dev-token'
    | '/provider-network'
    | '/ticketing'
    | '/analytics/report/$reportId'
    | '/auth/callback'
    | '/provider-network/clinics'
    | '/provider-network/groups'
    | '/provider-network/providers'
    | '/provider-network/clinic/$clinicId'
    | '/provider-network/group/$groupId'
    | '/provider-network/provider/$providerId'
  id:
    | '__root__'
    | '/'
    | '/analytics/'
    | '/change-to-e2e/'
    | '/component-catalog/'
    | '/copy-dev-token/'
    | '/provider-network/'
    | '/ticketing/'
    | '/analytics/report/$reportId'
    | '/auth/callback/'
    | '/provider-network/clinics/'
    | '/provider-network/groups/'
    | '/provider-network/providers/'
    | '/provider-network/clinic/$clinicId/'
    | '/provider-network/group/$groupId/'
    | '/provider-network/provider/$providerId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  ChangeToE2eIndexRoute: typeof ChangeToE2eIndexRoute
  ComponentCatalogIndexRoute: typeof ComponentCatalogIndexRoute
  CopyDevTokenIndexRoute: typeof CopyDevTokenIndexRoute
  ProviderNetworkIndexRoute: typeof ProviderNetworkIndexRoute
  TicketingIndexRoute: typeof TicketingIndexRoute
  AnalyticsReportReportIdRoute: typeof AnalyticsReportReportIdRoute
  AuthCallbackIndexRoute: typeof AuthCallbackIndexRoute
  ProviderNetworkClinicsIndexRoute: typeof ProviderNetworkClinicsIndexRoute
  ProviderNetworkGroupsIndexRoute: typeof ProviderNetworkGroupsIndexRoute
  ProviderNetworkProvidersIndexRoute: typeof ProviderNetworkProvidersIndexRoute
  ProviderNetworkClinicClinicIdIndexRoute: typeof ProviderNetworkClinicClinicIdIndexRoute
  ProviderNetworkGroupGroupIdIndexRoute: typeof ProviderNetworkGroupGroupIdIndexRoute
  ProviderNetworkProviderProviderIdIndexRoute: typeof ProviderNetworkProviderProviderIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ticketing/': {
      id: '/ticketing/'
      path: '/ticketing'
      fullPath: '/ticketing/'
      preLoaderRoute: typeof TicketingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider-network/': {
      id: '/provider-network/'
      path: '/provider-network'
      fullPath: '/provider-network/'
      preLoaderRoute: typeof ProviderNetworkIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copy-dev-token/': {
      id: '/copy-dev-token/'
      path: '/copy-dev-token'
      fullPath: '/copy-dev-token/'
      preLoaderRoute: typeof CopyDevTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/component-catalog/': {
      id: '/component-catalog/'
      path: '/component-catalog'
      fullPath: '/component-catalog/'
      preLoaderRoute: typeof ComponentCatalogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-to-e2e/': {
      id: '/change-to-e2e/'
      path: '/change-to-e2e'
      fullPath: '/change-to-e2e/'
      preLoaderRoute: typeof ChangeToE2eIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider-network/providers/': {
      id: '/provider-network/providers/'
      path: '/provider-network/providers'
      fullPath: '/provider-network/providers/'
      preLoaderRoute: typeof ProviderNetworkProvidersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider-network/groups/': {
      id: '/provider-network/groups/'
      path: '/provider-network/groups'
      fullPath: '/provider-network/groups/'
      preLoaderRoute: typeof ProviderNetworkGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider-network/clinics/': {
      id: '/provider-network/clinics/'
      path: '/provider-network/clinics'
      fullPath: '/provider-network/clinics/'
      preLoaderRoute: typeof ProviderNetworkClinicsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback/': {
      id: '/auth/callback/'
      path: '/auth/callback'
      fullPath: '/auth/callback/'
      preLoaderRoute: typeof AuthCallbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/report/$reportId': {
      id: '/analytics/report/$reportId'
      path: '/analytics/report/$reportId'
      fullPath: '/analytics/report/$reportId'
      preLoaderRoute: typeof AnalyticsReportReportIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider-network/provider/$providerId/': {
      id: '/provider-network/provider/$providerId/'
      path: '/provider-network/provider/$providerId'
      fullPath: '/provider-network/provider/$providerId/'
      preLoaderRoute: typeof ProviderNetworkProviderProviderIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider-network/group/$groupId/': {
      id: '/provider-network/group/$groupId/'
      path: '/provider-network/group/$groupId'
      fullPath: '/provider-network/group/$groupId/'
      preLoaderRoute: typeof ProviderNetworkGroupGroupIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider-network/clinic/$clinicId/': {
      id: '/provider-network/clinic/$clinicId/'
      path: '/provider-network/clinic/$clinicId'
      fullPath: '/provider-network/clinic/$clinicId/'
      preLoaderRoute: typeof ProviderNetworkClinicClinicIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  ChangeToE2eIndexRoute: ChangeToE2eIndexRoute,
  ComponentCatalogIndexRoute: ComponentCatalogIndexRoute,
  CopyDevTokenIndexRoute: CopyDevTokenIndexRoute,
  ProviderNetworkIndexRoute: ProviderNetworkIndexRoute,
  TicketingIndexRoute: TicketingIndexRoute,
  AnalyticsReportReportIdRoute: AnalyticsReportReportIdRoute,
  AuthCallbackIndexRoute: AuthCallbackIndexRoute,
  ProviderNetworkClinicsIndexRoute: ProviderNetworkClinicsIndexRoute,
  ProviderNetworkGroupsIndexRoute: ProviderNetworkGroupsIndexRoute,
  ProviderNetworkProvidersIndexRoute: ProviderNetworkProvidersIndexRoute,
  ProviderNetworkClinicClinicIdIndexRoute:
    ProviderNetworkClinicClinicIdIndexRoute,
  ProviderNetworkGroupGroupIdIndexRoute: ProviderNetworkGroupGroupIdIndexRoute,
  ProviderNetworkProviderProviderIdIndexRoute:
    ProviderNetworkProviderProviderIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
